export const BASE_URL = "https://sticky-12.herokuapp.com/api";

export const STATIC_URL = "https://sticky-12.herokuapp.com/uploads";
